export const getSacramentStructures = {
  success: true,
  isApp: false,
  sacraments: [
    {
      title: "Baptism",
      icon: "water fas",
      networkFieldID: 80,
      defaultFieldTypeInstanceMapping: "BaptismDate",
      columnType: 5,
      isCurrentlyOnBoard: false,
      subfields: [
        {
          title: "Godparents",
          icon: "user-friends fas",
          networkFieldID: 11,
          defaultFieldTypeInstanceMapping: "BaptismGodparents",
          columnType: 4,
          isCurrentlyOnBoard: false,
        },
        {
          title: "Witnesses",
          icon: "users fas",
          networkFieldID: 12,
          defaultFieldTypeInstanceMapping: "BaptismWitnesses",
          columnType: 4,
          isCurrentlyOnBoard: false,
        },
        {
          title: "Non-Catholic?",
          icon: "file-alt fas",
          networkFieldID: 13,
          defaultFieldTypeInstanceMapping: "BaptismNonCatholic",
          columnType: 8,
          isCurrentlyOnBoard: false,
        },
        {
          title: "Church",
          icon: "church fas",
          networkFieldID: 14,
          defaultFieldTypeInstanceMapping: "BaptismLocation",
          columnType: 4,
          isCurrentlyOnBoard: false,
        },
        {
          title: "Address",
          icon: "church fas",
          networkFieldID: 15,
          defaultFieldTypeInstanceMapping: "BaptismAddress",
          columnType: 7,
          isCurrentlyOnBoard: false,
        },
        {
          title: "Celebrant",
          icon: "user fas",
          networkFieldID: 16,
          defaultFieldTypeInstanceMapping: "BaptismCelebrant",
          columnType: 4,
          isCurrentlyOnBoard: false,
        },
        {
          title: "Received Through RCIA/OCIA",
          icon: "file-alt fas",
          networkFieldID: 17,
          defaultFieldTypeInstanceMapping: "BaptismReceivedThroughRCIAOCIA",
          columnType: 8,
          isCurrentlyOnBoard: false,
        },
        {
          title: "Notes",
          icon: "file-alt fas",
          networkFieldID: 18,
          defaultFieldTypeInstanceMapping: "BaptismNotes",
          columnType: 4,
          isCurrentlyOnBoard: false,
        },
        {
          title: "Record Book Page",
          icon: "book fas",
          networkFieldID: 20,
          defaultFieldTypeInstanceMapping: "BaptismRecordBookPage",
          columnType: 4,
          isCurrentlyOnBoard: false,
        },
        {
          title: "Certificate",
          icon: "file-certificate fas",
          networkFieldID: 22,
          defaultFieldTypeInstanceMapping: "BaptismCertificate",
          columnType: 16,
          isCurrentlyOnBoard: false,
        },
        {
          title: "At Current Church",
          icon: "church fas",
          networkFieldID: 23,
          defaultFieldTypeInstanceMapping: "BaptismAtCurrentChurch",
          columnType: 8,
          isCurrentlyOnBoard: false,
        },
      ],
    },
    {
      title: "First Reconciliation",
      icon: "praying-hands fas",
      networkFieldID: 24,
      defaultFieldTypeInstanceMapping: "FirstReconciliationDate",
      columnType: 5,
      isCurrentlyOnBoard: false,
      subfields: [
        {
          title: "Church",
          icon: "church fas",
          networkFieldID: 25,
          defaultFieldTypeInstanceMapping: "FirstReconciliationLocation",
          columnType: 4,
          isCurrentlyOnBoard: false,
        },
        {
          title: "Address",
          icon: "church fas",
          networkFieldID: 26,
          defaultFieldTypeInstanceMapping: "FirstReconciliationAddress",
          columnType: 7,
          isCurrentlyOnBoard: false,
        },
        {
          title: "Record Book Page",
          icon: "book fas",
          networkFieldID: 31,
          defaultFieldTypeInstanceMapping: "FirstReconciliationRecordBookPage",
          columnType: 4,
          isCurrentlyOnBoard: false,
        },
        {
          title: "Celebrant",
          icon: "user fas",
          networkFieldID: 27,
          defaultFieldTypeInstanceMapping: "FirstReconciliationCelebrant",
          columnType: 4,
          isCurrentlyOnBoard: false,
        },
        {
          title: "Certificate",
          icon: "file-certificate fas",
          networkFieldID: 28,
          defaultFieldTypeInstanceMapping: "FirstReconciliationCertificate",
          columnType: 16,
          isCurrentlyOnBoard: false,
        },
        {
          title: "Notes",
          icon: "file-alt fas",
          networkFieldID: 29,
          defaultFieldTypeInstanceMapping: "FirstReconciliationNotes",
          columnType: 4,
          isCurrentlyOnBoard: false,
        },
        {
          title: "Received Through RCIA/OCIA",
          icon: "file-alt fas",
          networkFieldID: 33,
          defaultFieldTypeInstanceMapping:
            "FirstReconciliationReceivedThroughRCIAOCIA",
          columnType: 8,
          isCurrentlyOnBoard: false,
        },
        {
          title: "At Current Church",
          icon: "church fas",
          networkFieldID: 34,
          defaultFieldTypeInstanceMapping: "FirstReconciliationAtCurrentChurch",
          columnType: 8,
          isCurrentlyOnBoard: false,
        },
      ],
    },
  ],
};
